module.exports = __webpack_public_path__ + "img/scalpel.2770496b.svg";